import RestrictedView from "shared/RestrictedView";
import { USER_PERMISSIONS } from "dyl-components";

import React from 'react';
import { Route } from 'react-router-dom';
import BannerDisplay from "pages/DYLAdmin/subcomponents/BannerDisplay";
import MessageHistory from "pages/DYLAdmin/subcomponents/MessageHistory";

export const DYL_ADMIN_ROUTES = [
    <Route index path='banner-display' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.LIBRARY_VIEW}><BannerDisplay /></RestrictedView>} />,
    <Route path='message-history' element={<RestrictedView type='restricted' userPermission={USER_PERMISSIONS.LIBRARY_VIEW}><MessageHistory /></RestrictedView>} />,
];
